import React, { Fragment, useEffect, useState } from 'react';
import queryString from 'query-string';
import SportsRight from '../../components/sports/SportsRight';
import connect from 'react-redux/lib/connect/connect';
import { ClearBetStore } from '../../common/actions/betAction';
import { ClearSportsList } from '../../common/actions/sportsAction';
import BetGameCenter from '../../components/BetGame/BetGameCenter';
import { isEmpty } from '../../common/cores';


const BetGame = (props) => {
  const [showLeft, setShowLeft] = useState(false);
  const [url, setUrl] = useState("")
  // props.ClearBetStore();
  // props.ClearSportsList();
  const match = props.match.url;
  const query = queryString.parse(props.location.search);
  const type = isEmpty(query.type) ? "Soccer" : query.type;

  return (
    <Fragment>
      <div className="title_wrap">
        <div className="title_box">
          <div className="title">벳365</div>
        </div>
      </div>

      <div className="contents_wrap">
        <div className="contents_box">
          <BetGameCenter type={type} match={match} url={url} />
          <SportsRight type="virtual" isbetting={true} />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {
  ClearBetStore,
  ClearSportsList,
})(BetGame);


// WEBPACK FOOTER //
// ./src/containers/BetGame/BetGame.js